import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/Reports/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { StaffList, DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'shortage',
    formatter(props) {
      return <>{dayjs(props.time_stamp).format('DD/MM/YYYY')}</>;
    },
    sortable: true,
  },
  {
    name: 'Cashier name',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Shift',
    key: 'cashier',
    formatter(props) {
      return <>{props.shift.shift}</>;
    },
  },
  {
    name: 'Shortage/ Excess',
    key: 'shortage',
    formatter(props) {
      return <>{formatCurrency(props.shortage)}</>;
    },
  },
  {
    name: 'Cumulative Shortage',
    key: 'shortage',
    formatter(props) {
      return <>{formatCurrency(props.total_shortage)}</>;
    },
  },
];

class CashierShortageReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shortageList: [],
      staff_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    //this.getShortageReport();
  }

  componentWillUnmount() {
    // No-op
  }

  handleLoadMore = () => {
    const { loading, count, limit, offset } = this.state;
    if (loading || count <= offset * limit) return;
    this.setState(
      (prevState) => ({ offset: prevState.offset + 1, loading: true }),
      () => this.getShortageReport(),
    );
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    const maxRangeMonths = 12;

    if (name === 'start_date') {
      const newStartDate = dayjs(value);
      const currentEndDate = dayjs(this.state.end_date);
      const maxEndDate = newStartDate.add(maxRangeMonths, 'month');

      // If new start date is after current end date, set end date to start date
      if (newStartDate.isAfter(currentEndDate)) {
        this.setState({ start_date: value, end_date: value });
      }
      // If end date exceeds 6 months from new start date, adjust end date
      else if (currentEndDate.isAfter(maxEndDate)) {
        this.setState({
          start_date: value,
          end_date: maxEndDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update start date
      else {
        this.setState({ start_date: value });
      }
    } else if (name === 'end_date') {
      const newEndDate = dayjs(value);
      const currentStartDate = dayjs(this.state.start_date);
      const minStartDate = newEndDate.subtract(maxRangeMonths, 'month');

      // If new end date is before current start date, set start date to end date
      if (newEndDate.isBefore(currentStartDate)) {
        this.setState({ end_date: value, start_date: value });
      }
      // If start date is more than 6 months before new end date, adjust start date
      else if (currentStartDate.isBefore(minStartDate)) {
        this.setState({
          end_date: value,
          start_date: minStartDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update end date
      else {
        this.setState({ end_date: value });
      }
    }
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      {
        limit: Number(this.limitInput.current.value),
        offset: 1,
        shortageList: [],
        count: 0,
      },
      () => {
        this.getShortageReport();
      },
    );
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        limit: 20,
        offset: 1,
      },
      () => {
        //this.getShortageReport();
      },
    );
  };

  getShortageReport = () => {
    const { staff_id, start_date, end_date, limit, offset } = this.state;
    this.setState({ loading: true });
    services
      .getCashierShortageReport({
        staff_id,
        start_date,
        end_date,
        limit,
        offset,
      })
      .then((response) => {
        this.setState((prevState) => ({
          shortageList:
            offset === 1
              ? response.data.data.results
              : [...prevState.shortageList, ...response.data.data.results],
          count: response.data.data.count,
          loading: false,
        }));
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ offset: 1 }, function () {
      this.getShortageReport();
    });
  };

  render() {
    const { shortageList, loading, count, limit, offset } = this.state;
    const hasMoreResults = count > offset * limit;

    return (
      <section className="widget list-table full-width inverted">
        <header>
          <h3> Cashier Shortage Report</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>

              <div className="filter-group">
                <label>Staff name:</label>
                <StaffList
                  value={this.state.staff_id}
                  onChange={this.handleStaffChange}
                  staffType={['Cashiers', 'Managers', 'Dealer']}
                />
              </div>
              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button type="submit" className="search-icon"></button>
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total shortage: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      shortageList[
                        shortageList.length - 1
                      ]?.shortage?.total_shortage.toFixed(2) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
            {(() => {
              if (loading && offset === 1) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={shortageList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    hideActions={true}
                    pagination="disabled"
                    exportOptions={{
                      fileName: ` Cashier Shortage - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                      reportName: 'Cashier Shortage Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total shortage -  ${shortageList[shortageList.length - 1]?.shortage?.total_shortage.toFixed(2) || 0}`,
                      reportQuantity: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                    }}
                  />
                );
              }
            })()}
            {hasMoreResults && (
              <div className="filter-group" style={{ marginTop: '12px' }}>
                <button
                  className={`submit ${loading ? 'loading' : ''}`}
                  disabled={loading}
                  type="button"
                  onClick={this.handleLoadMore}
                >
                  {loading ? 'Loading...' : 'Load More'}
                </button>
              </div>
            )}
          </div>
        </main>
      </section>
    );
  }
}

export { CashierShortageReport };
